export const canSetDemandForecast = process.env.CAN_SET_DEMAND_FORECAST === "true";
